import React from 'react';
import classnames from 'classnames';
import { Input } from '@1c/ui';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import Text from 'src/components/Text';
import styles from './styles.module.scss';

type Props = {
  label?: string;
  error?: string;
  className?: string;
  maskProps?: any;
  [x: string]: any;
}

const IntegerField: React.FC<Props> = ({ label, error, className, maskProps, ...rest }) => {
  const fieldClassNames = classnames(styles['input-field'], className);
  const mask = createNumberMask({
    prefix: '',
    includeThousandsSeparator: false,
    ...maskProps,
  });
  
  return (
    <div className={fieldClassNames}>
      {label && <Text type="span" muted className={styles['label']}>{label}</Text>}
      <Input
        {...rest}
        mask={mask}
        className={styles['input']}
      />
      {error && <Text type="span" small className={styles['error']}>{error}</Text>}
    </div>
  );
};

export default IntegerField;
